export default __webpack_public_path__ + "static/media/skel_bottle.2dc7befd.png";